import { FC, memo, Children, useState, ReactNode, useEffect } from 'react';
import styled from 'styled-components';
import { LayoutConst } from 'core';
import {BTagsGridNew} from "../../../../core/components/bTag/bTagsGridNew/bTagsGridNew";

const TagsMobileRoot = styled.div`
  position: relative;
  max-width: calc(100vw - 20px);

  #mobile-tags-container {
    @media(max-width: ${LayoutConst.screen.s -1}px) {
      width: 100%;
      ::-webkit-scrollbar {
        width: 3px;
        height: 2px;
      }
      ::-webkit-scrollbar-thumb {
        background: #909090;
      }
      ::-webkit-scrollbar-track {
        background: transparent;
      }
    }
  }
`;

const ExpandButton = styled.div`
  display: flex;
  align-items: center;
  margin-top: 10px;
  color: ${({ theme }) => theme.icon.default};

  :hover {
    color: ${({ theme }) => theme.icon.hover};
  }
`

export const ArrowIcon = styled.span<{ expanded: boolean }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 24px;
  width: 24px;
  transform: ${({ expanded }) => expanded ? 'none' : 'rotate(180deg)'};
  svg {
    width: 10px;
  }
`

type PropsT = {
  show: boolean;
  children: ReactNode;
  scroll?: boolean;
  background?: string;
};

const TagsMobile: FC<PropsT> = ({ show, children, scroll, background }) => {
  const [expanded, setExpanded] = useState(false);

  const tags = Children.toArray(children);
  const tagsToRender = expanded ? tags : [];

  useEffect(() => setExpanded(show), [show])
  return (
    <TagsMobileRoot>
      <BTagsGridNew
        id={'mobile-tags-container'}
        scrollMode="all"
        scroll={scroll}
        shadow={scroll}
        noLimitMaxHeight={!scroll}
      >
        {tagsToRender}
      </BTagsGridNew>
    </TagsMobileRoot>
  )
};

export default memo(TagsMobile)
import { FC, memo, Children, useState, ReactNode, useEffect } from 'react';
import styled from 'styled-components';
import { LayoutConst } from 'core';
import {BTagsGridNew} from "../../../../core/components/bTag/bTagsGridNew/bTagsGridNew";

const TagsMobileRoot = styled.div`
  position: relative;
  max-width: calc(100vw - 20px);

  #mobile-tags-container {
    @media(max-width: ${LayoutConst.screen.s -1}px) {
      width: 100%;
      ::-webkit-scrollbar {
        width: 3px;
        height: 2px;
      }
      ::-webkit-scrollbar-thumb {
        background: #909090;
      }
      ::-webkit-scrollbar-track {
        background: transparent;
      }
    }
  }
`;

const ExpandButton = styled.div`
  display: flex;
  align-items: center;
  margin-top: 10px;
  color: ${({ theme }) => theme.icon.default};

  :hover {
    color: ${({ theme }) => theme.icon.hover};
  }
`

export const ArrowIcon = styled.span<{ expanded: boolean }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 24px;
  width: 24px;
  transform: ${({ expanded }) => expanded ? 'none' : 'rotate(180deg)'};
  svg {
    width: 10px;
  }
`

type PropsT = {
  show: boolean;
  children: ReactNode;
  scroll?: boolean;
  background?: string;
};

const TagsMobile: FC<PropsT> = ({ show, children, scroll, background }) => {
  const [expanded, setExpanded] = useState(false);

  const tags = Children.toArray(children);
  const tagsToRender = expanded ? tags : [];

  useEffect(() => setExpanded(show), [show])
  return (
    <TagsMobileRoot>
      <BTagsGridNew
        id={'mobile-tags-container'}
        scrollMode="all"
        scroll={scroll}
        shadow={scroll}
        noLimitMaxHeight={!scroll}
      >
        {tagsToRender}
      </BTagsGridNew>
    </TagsMobileRoot>
  )
};

export default memo(TagsMobile)
